<template>
	<BurnUpChartTime
		:project-id="projectId"
		:retainer-period-id="retainerPeriodId"
	/>
</template>

<script setup lang="ts">
import { BurnUpChartTime } from '@/features/Project';
import { type RetainerPeriod, type Project } from '@/generated/graphql';

defineProps<{
	projectId: Project['id'];
	retainerPeriodId?: RetainerPeriod['id'];
}>();
</script>
